import { GridColDef, GridColumnGroupingModel, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import IGridComponent from '../../../components/grid/i-grid.component';
import TitlePanel from '../../../components/title-panel/title-panel.component';
import { DAYS_QTR, PAGE_SIZE } from '../../common/constants';
import { formatTo0Decimal, isEmpty, isEmptyArray, isNotEmpty } from '../../common/util.services';
import { getPrdReturn, getPrdReturnOverall, exportComment} from '../amazon.services';
import { Button, Grid, IconButton, Stack, Tooltip } from '@mui/material';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import '../amazon.scss';
import IReadOnlyField from '../../../components/text-component/readonly-field/i-readonlyfield.component';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import IDialogComponent from '../../../components/dialog/i-dialog.component';
import AmazonProductReturn from './product-return.component';
import AmazonReturnComment from './return-comment.component';
import * as XLSX from 'xlsx';
import SearchPanel from '../../../components/search-panel/search-panel.component';
import IDateField from '../../../components/text-component/i-datefield/i-datefield.component';
import IDropdown from '../../../components/text-component/dropdown/i-dropdown.component';
import { AssessmentOutlined } from '@mui/icons-material';
import PieChartIcon from '@mui/icons-material/PieChart';
import ProductReturnTrendMonthly from './return-trend-monthly.component';
import ProductReturnTrendTotal from './return-trend-total.component';
import ProductReturnReasonChart from './return-reason-chart.component';

const AmazonAllProductReturn = () => {
  const appContext = useContext(AppContext);
  const rows: GridRowsProp = [];
  dayjs.extend(utc);
  dayjs.extend(timezone);
  const [searchData, setSearchData] = useState<any>({period: 'Monthly', type: 'ASIN Unit', 
                                                     startDate: dayjs().subtract(DAYS_QTR, 'day'), endDate: dayjs()});
  const [openPrd, setOpenPrd] = useState(false);
  const [openComment, setOpenComment] = useState(false);
  const [productData, setProductData] = useState([]);
  const [product, setProduct] = useState('');
  const [prdReturnOverall, setPrdReturnOverall] = useState<any>([])
  const [prdReturnData, setPrdReturnData] = useState([{period: 'Loading...'}])
  const [openMonthlyChart, setOpenMonthlyChart] = useState(false);
  const [openTotalChart, setOpenTotalChart] = useState(false);
  const [openReasonChart, setOpenReasonChart] = useState(false);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);
  const columns: GridColDef[] = [
    { field: 'period', headerName: 'Period', filterable: false, sortable: false, editable: false, width: 110,
      cellClassName: (params) => { return "Tacos2" }
    },
    { field: 'countTotal', headerName: 'Ret #', width: 60, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.countTotal, params.row.saleTotal) },
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'saleTotal', headerName: 'Sale #', width: 60, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleTotal) },
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'pctTotal', headerName: 'Ret %', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.pctTotal, params.row.saleTotal) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countSalsaNapkin', headerName: 'Ret #', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.countSalsaNapkin, params.row.saleSalsaNapkin) },
    },
    { field: 'saleSalsaNapkin', headerName: 'Sale #', width: 60, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleSalsaNapkin) },
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'pctSalsaNapkin', headerName: 'Ret %', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.pctSalsaNapkin, params.row.saleSalsaNapkin) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countLaundryBag', headerName: 'Ret #', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.countLaundryBag, params.row.saleLaundryBag) },
    },
    { field: 'saleLaundryBag', headerName: 'Sale #', width: 60, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleLaundryBag) },
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'pctLaundryBag', headerName: 'Ret %', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.pctLaundryBag, params.row.saleLaundryBag) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countShoeBag', headerName: 'Ret #', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.countShoeBag, params.row.saleShoeBag) },
    },
    { field: 'saleShoeBag', headerName: 'Sale #', width: 60, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleShoeBag) },
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'pctShoeBag', headerName: 'Ret %', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.pctShoeBag, params.row.saleShoeBag) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countBsPlacemat', headerName: 'Ret #', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.countBsPlacemat, params.row.saleBsPlacemat) },
    },
    { field: 'saleBsPlacemat', headerName: 'Sale #', width: 60, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleBsPlacemat) },
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'pctBsPlacemat', headerName: 'Ret %', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.pctBsPlacemat, params.row.saleBsPlacemat) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countBsRunner', headerName: 'Ret #', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.countBsRunner, params.row.saleBsRunner) },
    },
    { field: 'saleBsRunner', headerName: 'Sale #', width: 60, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleBsRunner) },
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'pctBsRunner', headerName: 'Ret %', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.pctBsRunner, params.row.saleBsRunner) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countCanvasTableCloth', headerName: 'Ret #', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.countCanvasTableCloth, params.row.saleCanvasTableCloth) },
    },
    { field: 'saleCanvasTableCloth', headerName: 'Sale #', width: 60, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleCanvasTableCloth) },
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'pctCanvasTableCloth', headerName: 'Ret %', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.pctCanvasTableCloth, params.row.saleCanvasTableCloth) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countWineBottleCover', headerName: 'Ret #', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.countWineBottleCover, params.row.saleWineBottleCover) },
    },
    { field: 'saleWineBottleCover', headerName: 'Sale #', width: 60, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleWineBottleCover) },
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'pctWineBottleCover', headerName: 'Ret %', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.pctWineBottleCover, params.row.saleWineBottleCover) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countBsCushionCover', headerName: 'Ret #', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.countBsCushionCover, params.row.saleBsCushionCover) },
    },
    { field: 'saleBsCushionCover', headerName: 'Sale #', width: 60, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleBsCushionCover) },
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'pctBsCushionCover', headerName: 'Ret %', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.pctBsCushionCover, params.row.saleBsCushionCover) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countFoutaTowel', headerName: 'Ret #', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.countFoutaTowel, params.row.saleFoutaTowel) },
    },
    { field: 'saleFoutaTowel', headerName: 'Sale #', width: 60, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleFoutaTowel) },
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'pctFoutaTowel', headerName: 'Ret %', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.pctFoutaTowel, params.row.saleFoutaTowel) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countDobbyNapkin', headerName: 'Ret #', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.countDobbyNapkin, params.row.saleDobbyNapkin) },
    },
    { field: 'saleDobbyNapkin', headerName: 'Sale #', width: 60, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleDobbyNapkin) },
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'pctDobbyNapkin', headerName: 'Ret %', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.pctDobbyNapkin, params.row.saleDobbyNapkin) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countCanvasCurtain', headerName: 'Ret #', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.countCanvasCurtain, params.row.saleCanvasCurtain) },
    },
    { field: 'saleCanvasCurtain', headerName: 'Sale #', width: 60, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleCanvasCurtain) },
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'pctCanvasCurtain', headerName: 'Ret %', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.pctCanvasCurtain, params.row.saleCanvasCurtain) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countSlubDuck', headerName: 'Ret #', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.countSlubDuck, params.row.saleSlubDuck) },
    },
    { field: 'saleSlubDuck', headerName: 'Sale #', width: 60, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleSlubDuck) },
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'pctSlubDuck', headerName: 'Ret %', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.pctSlubDuck, params.row.saleSlubDuck) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countCottonYogaMat', headerName: 'Ret #', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.countCottonYogaMat, params.row.saleCottonYogaMat) },
    },
    { field: 'saleCottonYogaMat', headerName: 'Sale #', width: 60, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleCottonYogaMat) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '' : getValue0Decimal(value)
    },
    { field: 'pctCottonYogaMat', headerName: 'Ret %', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.pctCottonYogaMat, params.row.saleCottonYogaMat) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countStrawYogaMat', headerName: 'Ret #', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.countStrawYogaMat, params.row.saleStrawYogaMat) },
    },
    { field: 'saleStrawYogaMat', headerName: 'Sale #', width: 60, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleStrawYogaMat) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '' : getValue0Decimal(value)
    },
    { field: 'pctStrawYogaMat', headerName: 'Ret %', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.pctStrawYogaMat, params.row.saleStrawYogaMat) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countUtilityBag', headerName: 'Ret #', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.countUtilityBag, params.row.saleUtilityBag) },
    },
    { field: 'saleUtilityBag', headerName: 'Sale #', width: 60, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleUtilityBag) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '' : getValue0Decimal(value)
    },
    { field: 'pctUtilityBag', headerName: 'Ret %', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.pctUtilityBag, params.row.saleUtilityBag) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countCheckRunner', headerName: 'Ret #', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.countCheckRunner, params.row.saleCheckRunner) },
    },
    { field: 'saleCheckRunner', headerName: 'Sale #', width: 60, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleCheckRunner) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '' : getValue0Decimal(value)
    },
    { field: 'pctCheckRunner', headerName: 'Ret %', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.pctCheckRunner, params.row.saleCheckRunner) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countFlaxNapkin', headerName: 'Ret #', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.countFlaxNapkin, params.row.saleFlaxNapkin) },
    },
    { field: 'saleFlaxNapkin', headerName: 'Sale #', width: 60, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleFlaxNapkin) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '' : getValue0Decimal(value)
    },
    { field: 'pctFlaxNapkin', headerName: 'Ret %', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.pctFlaxNapkin, params.row.saleFlaxNapkin) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countCushionCover', headerName: 'Ret #', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.countCushionCover, params.row.saleCushionCover) },
    },
    { field: 'saleCushionCover', headerName: 'Sale #', width: 60, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleCushionCover) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '' : getValue0Decimal(value)
    },
    { field: 'pctCushionCover', headerName: 'Ret %', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.pctCushionCover, params.row.saleCushionCover) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countCheckNapkin', headerName: 'Ret #', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.countCheckNapkin, params.row.saleCheckNapkin) },
    },
    { field: 'saleCheckNapkin', headerName: 'Sale #', width: 60, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleCheckNapkin) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '' : getValue0Decimal(value)
    },
    { field: 'pctCheckNapkin', headerName: 'Ret %', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.pctCheckNapkin, params.row.saleCheckNapkin) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countPlainNapkin', headerName: 'Ret #', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.countPlainNapkin, params.row.salePlainNapkin) },
    },
    { field: 'salePlainNapkin', headerName: 'Sale #', width: 60, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.salePlainNapkin) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '' : getValue0Decimal(value)
    },
    { field: 'pctPlainNapkin', headerName: 'Ret %', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.pctPlainNapkin, params.row.salePlainNapkin) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countKitchenTowel', headerName: 'Ret #', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.countKitchenTowel, params.row.saleKitchenTowel) },
    },
    { field: 'saleKitchenTowel', headerName: 'Sale #', width: 60, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleKitchenTowel) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '' : getValue0Decimal(value)
    },
    { field: 'pctKitchenTowel', headerName: 'Ret %', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.pctKitchenTowel, params.row.saleKitchenTowel) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countStrawMat', headerName: 'Ret #', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.countStrawMat, params.row.saleStrawMat) },
    },
    { field: 'saleStrawMat', headerName: 'Sale #', width: 60, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleStrawMat) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '' : getValue0Decimal(value)
    },
    { field: 'pctStrawMat', headerName: 'Ret %', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.pctStrawMat, params.row.saleStrawMat) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    },
    { field: 'countBambooMat', headerName: 'Ret #', width: 60, filterable: false, sortable: false,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.countBambooMat, params.row.saleBambooMat) },
    },
    { field: 'saleBambooMat', headerName: 'Sale #', width: 60, filterable: false, sortable: false,
      cellClassName: (params) => { return getClassNamePrdSale(params.row.saleBambooMat) },
      valueFormatter: (value: any) => 'NA' === getValue0Decimal(value) ? '' : getValue0Decimal(value)
    },
    { field: 'pctBambooMat', headerName: 'Ret %', width: 65, filterable: false, sortable: false, 
      cellClassName: (params) => { return getClassNamePrdReturn(params.row.pctBambooMat, params.row.saleBambooMat) },
      valueFormatter: (value: any) => getValuePctDecimal(value)
    }
  ];
  const popperProps = {sx: {'.MuiTooltip-tooltip': {bgcolor: 'ivory', fontSize: 16, color: 'black', border: 1}}};
  const columnGroupingModel: GridColumnGroupingModel = [
    { groupId: 'Ret Trend', headerAlign: 'left', headerClassName: 'Tacos2',
      children: [{ field: 'period' }],
      renderHeaderGroup: (params) => (<Stack direction="row" spacing={0} alignItems="center" justifyContent="center">
                                      <Tooltip title={'Monthly Return Trend'} PopperProps={popperProps}>
                                      <IconButton size="small" onClick={openReturnMonthlyChart} sx={{ p: 0.6 }}>
                                        <AssessmentOutlined fontSize="small" color='primary'/></IconButton></Tooltip>
                                      <Tooltip title={'Total Return Trend'} PopperProps={popperProps}>
                                      <IconButton size="small" onClick={openReturnTotalChart} sx={{ p: 0.6 }}>
                                        <AssessmentOutlined fontSize="small" color='secondary'/></IconButton></Tooltip>
                                      <Tooltip title={'Return Reason Distribution'} PopperProps={popperProps}>
                                      <IconButton size="small" onClick={openReturnReasonChart} sx={{ p: 0.6 }}>
                                        <PieChartIcon fontSize="small" color='secondary'/></IconButton></Tooltip>
                                      </Stack>)},
    { groupId: 'Total', headerAlign: 'center', headerClassName: 'Tacos1',
      children: [{ field: 'countTotal' }, { field: 'saleTotal' }, { field: 'pctTotal' }]},
    { groupId: 'Salsa Napkin', headerAlign: 'center', headerClassName: 'Tacos2',
      children: [{ field: 'countSalsaNapkin' }, { field: 'saleSalsaNapkin' }, { field: 'pctSalsaNapkin' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                        onClick={() => { openPrdReturn(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'Laundry Bag', headerAlign: 'center', headerClassName: 'Tacos1',
      children: [{ field: 'countLaundryBag' }, { field: 'saleLaundryBag' }, { field: 'pctLaundryBag' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                        onClick={() => { openPrdReturn(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'Shoe Bag', headerAlign: 'center', headerClassName: 'Tacos2',
      children: [{ field: 'countShoeBag' }, { field: 'saleShoeBag' }, { field: 'pctShoeBag' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                          onClick={() => { openPrdReturn(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'BS Placemat', headerAlign: 'center', headerClassName: 'Tacos1',
      children: [{ field: 'countBsPlacemat' }, { field: 'saleBsPlacemat' }, { field: 'pctBsPlacemat' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                          onClick={() => { openPrdReturn(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'BS Runner', headerAlign: 'center', headerClassName: 'Tacos2',
      children: [{ field: 'countBsRunner' }, { field: 'saleBsRunner' }, { field: 'pctBsRunner' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                          onClick={() => { openPrdReturn(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'Canvas Table Cloth', headerAlign: 'center', headerClassName: 'Tacos1',
      children: [{ field: 'countCanvasTableCloth' }, { field: 'saleCanvasTableCloth' }, { field: 'pctCanvasTableCloth' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                          onClick={() => { openPrdReturn(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'Wine Bottle Cover', headerAlign: 'center', headerClassName: 'Tacos2',
      children: [{ field: 'countWineBottleCover' }, { field: 'saleWineBottleCover' }, { field: 'pctWineBottleCover' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                          onClick={() => { openPrdReturn(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'BS Cushion Cover', headerAlign: 'center', headerClassName: 'Tacos1',
      children: [{ field: 'countBsCushionCover' }, { field: 'saleBsCushionCover' }, { field: 'pctBsCushionCover' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                          onClick={() => { openPrdReturn(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'Fouta Towel', headerAlign: 'center', headerClassName: 'Tacos2',
      children: [{ field: 'countFoutaTowel' }, { field: 'saleFoutaTowel' }, { field: 'pctFoutaTowel' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                          onClick={() => { openPrdReturn(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'Dobby Napkin', headerAlign: 'center', headerClassName: 'Tacos1',
      children: [{ field: 'countDobbyNapkin' }, { field: 'saleDobbyNapkin' }, { field: 'pctDobbyNapkin' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                          onClick={() => { openPrdReturn(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'Canvas Curtain', headerAlign: 'center', headerClassName: 'Tacos2',
      children: [{ field: 'countCanvasCurtain' }, { field: 'saleCanvasCurtain' }, { field: 'pctCanvasCurtain' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                          onClick={() => { openPrdReturn(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'Slub Duck', headerAlign: 'center', headerClassName: 'Tacos1',
      children: [{ field: 'countSlubDuck' }, { field: 'saleSlubDuck' }, { field: 'pctSlubDuck' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                        onClick={() => { openPrdReturn(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'Cotton Yoga Mat', headerAlign: 'center', headerClassName: 'Tacos2',
      children: [{ field: 'countCottonYogaMat' }, { field: 'saleCottonYogaMat' }, { field: 'pctCottonYogaMat' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                        onClick={() => { openPrdReturn(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'Straw Yoga Mat', headerAlign: 'center', headerClassName: 'Tacos1',
      children: [{ field: 'countStrawYogaMat' }, { field: 'saleStrawYogaMat' }, { field: 'pctStrawYogaMat' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                        onClick={() => { openPrdReturn(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'Utility Bag', headerAlign: 'center', headerClassName: 'Tacos2',
      children: [{ field: 'countUtilityBag' }, { field: 'saleUtilityBag' }, { field: 'pctUtilityBag' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                        onClick={() => { openPrdReturn(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'Check Runner', headerAlign: 'center', headerClassName: 'Tacos1',
      children: [{ field: 'countCheckRunner' }, { field: 'saleCheckRunner' }, { field: 'pctCheckRunner' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                        onClick={() => { openPrdReturn(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'Flax Napkin', headerAlign: 'center', headerClassName: 'Tacos2',
      children: [{ field: 'countFlaxNapkin' }, { field: 'saleFlaxNapkin' }, { field: 'pctFlaxNapkin' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                        onClick={() => { openPrdReturn(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'Cushion Cover', headerAlign: 'center', headerClassName: 'Tacos1',
      children: [{ field: 'countCushionCover' }, { field: 'saleCushionCover' }, { field: 'pctCushionCover' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                        onClick={() => { openPrdReturn(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'Check Napkin', headerAlign: 'center', headerClassName: 'Tacos2',
      children: [{ field: 'countCheckNapkin' }, { field: 'saleCheckNapkin' }, { field: 'pctCheckNapkin' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                        onClick={() => { openPrdReturn(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'Plain Napkin', headerAlign: 'center', headerClassName: 'Tacos1',
      children: [{ field: 'countPlainNapkin' }, { field: 'salePlainNapkin' }, { field: 'pctPlainNapkin' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                        onClick={() => { openPrdReturn(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'Kitchen Towel', headerAlign: 'center', headerClassName: 'Tacos2',
      children: [{ field: 'countKitchenTowel' }, { field: 'saleKitchenTowel' }, { field: 'pctKitchenTowel' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                        onClick={() => { openPrdReturn(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'Straw Mat', headerAlign: 'center', headerClassName: 'Tacos1',
      children: [{ field: 'countStrawMat' }, { field: 'saleStrawMat' }, { field: 'pctStrawMat' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                        onClick={() => { openPrdReturn(params.headerName)}}>{params.headerName}</Button>)},
    { groupId: 'Bamboo Mat', headerAlign: 'center', headerClassName: 'Tacos2',
      children: [{ field: 'countBambooMat' }, { field: 'saleBambooMat' }, { field: 'pctBambooMat' }],
      renderHeaderGroup: (params) => (<Button endIcon={<HelpOutlineIcon color='primary'/>} sx={{ textTransform: 'none', color: 'black' }}
                                        onClick={() => { openPrdReturn(params.headerName)}}>{params.headerName}</Button>)}
  ];

  function getClassNamePrdReturn(ret: any, sale: any) {
    if(isNotEmpty(sale) && 0 !== sale && (isEmpty(ret) || 0 === ret)) {
      return 'PrdSalePositive';
    } else if(isNotEmpty(sale) && 0 !== sale && (isNotEmpty(ret) && 0 !== ret)) {
      return 'PrdSaleNegative';
    } else {
      return '';
    }
  }

  const openReturnMonthlyChart = () => {
    setOpenMonthlyChart(true);
  }

  const closeMonthlyChart = () => {
    setOpenMonthlyChart(false);
  }

  const openReturnTotalChart = () => {
    setOpenTotalChart(true);
  }

  const closeTotalChart = () => {
    setOpenTotalChart(false);
  }

  const openReturnReasonChart = () => {
    setOpenReasonChart(true);
  }

  const closeReturnReasonChart = () => {
    setOpenReasonChart(false);
  }

  function getClassNamePrdSale(value: any) {
    return isEmpty(value) || 0 === value ? '' : '';
  }

  useEffect(() => {
    getPrdReturnData();
  }, [page, pageSize, searchData]);

  function getPrdReturnData() {
    if (isEmptyArray(rows)) {
      setLoading(true);
      getPrdReturn(searchData, page, pageSize, appContext,
        (response: any) => {
          setPrdReturnData(response.data.content);
          setTotalRows(response.data.totalElements);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  }

  useEffect(() => {
    setLoading(true);
    getPrdReturnOverall(searchData, appContext,
      (response: any) => {
        setPrdReturnOverall(response.data);
        appContext.setShowLoader(false);
        setLoading(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  }, [searchData]);

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }

  const openPrdReturn = (value: any) => {
    let data: any = [value, searchData.startDate, searchData.endDate];
    setProductData(data);
    setOpenPrd(true);
  }

  const getValue0Decimal = (value: any) => {
    return isEmpty(value) ? '0' : formatTo0Decimal(Math.round(value * 1));
  }

  const getValuePctDecimal = (value: any) => {
    return isEmpty(value) ? '0%' : formatTo0Decimal(Math.round(value)) + '%';
  }

  const getRetPct = (value: any) => {
    return isEmpty(prdReturnOverall[value]) ? '0%' : formatTo0Decimal(prdReturnOverall[value]) + '%';
  }

  const search = (data: any) => {
    setPage(0);
    setSearchData(data);
  }
  
  const closePrdPopup = (e: any) => {
    setOpenPrd(false);
  }

  const closeComment = (e: any) => {
    setOpenComment(false);
  }

  const saveExcel = (commentData: any) => {
    const workBook = XLSX.utils.book_new();
    let map: any = Object.entries(commentData);
    for(let i = 0; i < map.length; ++i) {
      XLSX.utils.book_append_sheet(workBook, XLSX.utils.aoa_to_sheet(map[i][1]), map[i][0]);
    }
    XLSX.writeFile(workBook, "Return_Comment.xlsx");
  }

  const exportCommentData = () => {
    exportComment(searchData.startDate, searchData.endDate, appContext,
      (response: any) => {
        saveExcel(response.data);
        setLoading(false);
      }, (error: any) => {
        console.log(error);
        setLoading(false);
      });
  }

  const onColumnHeaderClick = (value: any) => {
    const field: string = value.field;
    if(field.includes('count') && field !== 'countTotal') {
      setProduct(field.substring(5));
      setOpenComment(true);
    }
  }

  const getSearchComponent = () => {
    return <SearchPanel search={search} formData={searchData} export={exportCommentData} showExportBtn={true}>
      <Grid container spacing={1}>
        <Grid xs={3}>
          <IDateField name='startDate' label='Start Date' timeZone="America/Los_Angeles"/>
        </Grid>
        <Grid xs={3}>
          <IDateField name='endDate' label='End Date' timeZone="America/Los_Angeles"/>
        </Grid>
        <Grid xs={3}>
          <IDropdown name='period' label='Period' itemList={['Daily', 'Monthly']} required={true} />
        </Grid>
        <Grid xs={3}>
          <IDropdown name='type' label='Type' itemList={['ASIN Unit', 'Total Unit']} required={true} />
        </Grid>
      </Grid>
    </SearchPanel>
  }

  const getMainPanel = () => {
    return <>
      {getSearchComponent()}
      <Grid xs={12} display="flex" justifyContent="center">
        <Grid container columnSpacing={1} rowSpacing={0} sx={{ maxWidth: '1380px', mt: 2, border: '1px solid #D3D3D3', borderRadius: '4px', p: 2}}>
          <Grid xs={2}>
            <IReadOnlyField label='Days' value={prdReturnOverall.Days}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Total' value={getRetPct('Total')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Salsa Napkin' value={getRetPct('Salsa Napkin')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Laundry Bag' value={getRetPct('Laundry Bag')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Shoe Bag' value={getRetPct('Shoe Bag')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Slub Duck' value={getRetPct('Slub Duck')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Canvas Curtain' value={getRetPct('Canvas Curtain')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Cotton Yoga Mat' value={getRetPct('Cotton Yoga Mat')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Straw Yoga Mat' value={getRetPct('Straw Yoga Mat')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Utility Bag' value={getRetPct('Utility Bag')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Fouta Towel' value={getRetPct('Fouta Towel')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='BS Runner' value={getRetPct('BS Runner')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='BS Placemat' value={getRetPct('BS Placemat')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='BS Cushion Cover' value={getRetPct('BS Cushion Cover')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Wine Bottle Cover' value={getRetPct('Wine Bottle Cover')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Dobby Napkin' value={getRetPct('Dobby Napkin')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Canvas Table Cloth' value={getRetPct('Canvas Table Cloth')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Check Runner' value={getRetPct('Check Runner')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Flax Napkin' value={getRetPct('Flax Napkin')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Cushion Cover' value={getRetPct('Cushion Cover')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Check Napkin' value={getRetPct('Check Napkin')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Plain Napkin' value={getRetPct('Plain Napkin')}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Kitchen Towel' value={getRetPct('Kitchen Towel')}/>
          </Grid>
        </Grid>
      </Grid>
      <IGridComponent title={''} rows={prdReturnData} columns={columns} loading={loading} maxHeight={450}
          showExtraText={true} extraText='Click on "Ret #" column header to see the return comments' extraTextColor='blue'
          paginationType="server" paginationModelChange={onPaginationModelChange} totalRows={totalRows}
          getRowId={(row: any) => row.period} columnGroupingModel={columnGroupingModel} onColumnHeaderClick={onColumnHeaderClick}
          showExtBtn={false} extBtnText={'Export Comment'} extBtnAction={exportCommentData}
          showAction={false} showApproveAction={false} showDeleteAction={false} showEditAction={false} />
      <IDialogComponent onClose={closePrdPopup} open={openPrd} title={'Product Return'}
        dialogBody={<AmazonProductReturn productData={productData}/>} />
      <IDialogComponent onClose={closeComment} open={openComment} title={'Return Comment'}
        dialogBody={<AmazonReturnComment product={product}/>} />
      <IDialogComponent onClose={closeMonthlyChart} open={openMonthlyChart} title='Monthly Return Trend' 
        dialogBody={<ProductReturnTrendMonthly />} />
      <IDialogComponent onClose={closeTotalChart} open={openTotalChart} title='Total Return Trend' 
        dialogBody={<ProductReturnTrendTotal />} />
      <IDialogComponent onClose={closeReturnReasonChart} open={openReasonChart} title='Return Reason Distribution' 
        dialogBody={<ProductReturnReasonChart />} />
    </>
  }

  return <TitlePanel title='Product Return' panelBody={getMainPanel()} />
}

export default AmazonAllProductReturn;